import { SaveButton } from "components/Buttons"
import { TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  arrayPush,
  Field,
  FieldArray,
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import { renderQuestionsForm } from "./utils"
import {
  addTriviaChallenge,
  cloneMenuFeature,
  displayLockWarningModal,
  getTriviaChallenge,
  getTriviaChallengeList,
  hideLockWarningModal,
  resetTriviaChallenge,
  updateTriviaChallenge,
} from "store/actions"
import {
  CloneFeatureModal,
  mapApiResponseToTrivia,
  mapTriviaChallengeToAPi,
  mapUpdatedTriviaToApi,
} from "../utils"
import validate from "./triviaChallengeValidation"
import PropTypes from "prop-types"
import Preview from "./preview"
import PhoneArea from "components/PhonePreview/PhoneArea"
import ResultPreview from "./resultPreview"
import { getPointsAxios } from "helpers/api_helper"
import ModalComponent from "components/Modals"
import { LoadingIndicator } from "components/LoadingIndicator"

let TriviaChallenge = props => {
  const [previewToggle, setPreviewToggle] = useState(true)
  const [hasReplies, setHasReplies] = useState(false)

  useEffect(() => {
    const getHasReplies = async () => {
      try {
        const { has_replies } = await getPointsAxios(
          `/trivia/${props.feature.entity_id}/has-replies`
        )
        setHasReplies(has_replies)
      } catch (error) {
        console.error(error)
      }
    }

    if (props.feature.entity_id) {
      getHasReplies()
      props.getTriviaChallenge(props.feature.entity_id)
    }

    return () => {
      props.resetTriviaChallenge()
    }
  }, [])

  useEffect(() => {
    if (props.triviaChallenge) {
      props.initializeForm(mapApiResponseToTrivia(props.triviaChallenge))
    }
  }, [props.triviaChallenge])

  const submitHandler = data => {
    const [questions, trivia] = mapTriviaChallengeToAPi({
      ...data.trivia_challenge_form,
      eventId: !!props?.selectedEvent ? props.selectedEvent.id : null,
      menu_feature: true,
      menu_item_id: props.feature.id,
      name: props.feature.label,
      order: 0,
      status: 0,
      userId: props.userId,
      vendorId: props.vendorId,
    })
    if (!props.triviaChallenge) {
      props.addTriviaChallenge({ questions, trivia })
    } else {
      const [newQuestions, updatedQuestions, trivia] = mapUpdatedTriviaToApi(
        data.trivia_challenge_form,
        props.triviaChallenge
      )
      props.updateTriviaChallenge({ newQuestions, updatedQuestions, trivia })
    }
  }

  const handleFieldFocus = event => {
    if (hasReplies) {
      event.preventDefault()
      props.displayLockWarningModal()
    }
  }

  return (
    <React.Fragment>
      <FormSection name={props.form}>
        {props?.triviaLoading ? (
          <LoadingIndicator />
        ) : (
          <Card>
            <CardBody className="shadow-sm">
              <Row className="mb-3">
                <Col>
                  <h3>{props.feature.label}</h3>
                </Col>
                {props.isListItem && (
                  <Col xs="auto">
                    <SaveButton
                      type="button"
                      content="Cancel"
                      color="light"
                      onClick={props.backButtonHandler}
                    />
                  </Col>
                )}
                <Col xs="auto">
                  <SaveButton
                    content="Save"
                    type="button"
                    onClick={
                      props.isListItem
                        ? props.handleSubmit(props.handleAddListItem)
                        : props.handleSubmit(submitHandler)
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  {props.isListItem && (
                    <Card>
                      <CardHeader>
                        <h4>CREATE A NAME FOR YOUR TRIVIA CHALLENGE</h4>
                      </CardHeader>
                      <CardBody>
                        <Row>
                          <Col>
                            <Field
                              name="name"
                              component={TextField}
                              label="Name"
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  )}
                  <Card>
                    <CardHeader>
                      <h4>TRIVIA CHALLENGE QUESTIONS</h4>
                    </CardHeader>
                    <CardBody>
                      <Row className="mb-3">
                        <Col>
                          <span>
                            Create your Trivia questions and give answer
                            choices. You can have up to 10 questions with up to
                            5 answers each. <br />
                            Drag & drop{" "}
                            <i className="bx bx-sm bx-menu align-middle" /> to
                            reorder questions, then click on "Save".
                          </span>
                        </Col>
                      </Row>
                      <Row className="my-3">
                        <Col>
                          <FieldArray
                            name="questions"
                            component={renderQuestionsForm}
                            hasReplies={hasReplies}
                            handleFieldFocus={handleFieldFocus}
                          />
                        </Col>
                      </Row>
                      {props.questions && props.questions?.length < 10 && (
                        <Row>
                          <Col>
                            <h5
                              style={{ cursor: "pointer" }}
                              onClick={
                                hasReplies
                                  ? () => {}
                                  : () => {
                                      props.addForm(
                                        FORM_NAMES.TRIVIA_CHALLENGE,
                                        "trivia_challenge_form.questions",
                                        {
                                          answers: [
                                            { id: null, answer: "" },
                                            { id: null, answer: "" },
                                          ],
                                          question: "",
                                        }
                                      )
                                    }
                              }
                            >
                              + Add Another Trivia Challenge Question
                            </h5>
                          </Col>
                        </Row>
                      )}
                    </CardBody>
                  </Card>
                  <Row className="my-2">
                    <Col className="d-flex justify-content-center">
                      <SaveButton
                        type="button"
                        content="Save"
                        onClick={
                          props.isListItem
                            ? props.handleSubmit(props.handleAddListItem)
                            : props.handleSubmit(submitHandler)
                        }
                      />
                    </Col>
                  </Row>
                </Col>
                <Col xl={4} className="mt-4 custom-features-preview">
                  <Row>
                    <p style={{ textAlign: "center", margin: "0px" }}>
                      <b>
                        {previewToggle ? "Question Preview" : "Results Preview"}
                      </b>
                    </p>
                  </Row>
                  <Row xs="auto" className="d-flex justify-content-center my-2">
                    <SaveButton
                      type="button"
                      content="Toggle Screens"
                      onClick={() => setPreviewToggle(!previewToggle)}
                    />
                  </Row>
                  {previewToggle ? (
                    <Preview
                      menu_bg_color={props.design?.menu_bg_color}
                      bgImage={props.design?.bg_image_url}
                      label={props?.formValues?.name || props?.feature?.label}
                      questions={props.formValues?.questions}
                    />
                  ) : (
                    <ResultPreview
                      bgImage={props.design?.bg_image_url}
                      label={props?.formValues?.name || props?.feature?.label}
                    />
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </FormSection>
      <ModalComponent
        title={`Clone Trivia Menu Feature`}
        open={props.lockWarningModalIsOpen}
        onClose={props.hideLockWarningModal}
        returnFocusAfterClose={false}
      >
        <CloneFeatureModal
          handleClone={() => {
            props?.cloneMenuFeature({
              data: {
                vendor_id: +props?.vendorId,
                entity_type: "trivia",
                entity_id: props?.triviaChallenge?.id,
                menu_item_id: props?.triviaChallenge?.menu_item_id,
              },
              callback: props?.isListItem
                ? () => {
                    props.getTriviaChallengeList({
                      menu_item_id: props.triviaChallenge?.menu_item_id,
                      vendor_id: parseInt(props.vendorId),
                      ...(!!props?.selectedEvent
                        ? { event_id: props.selectedEvent.id }
                        : {}),
                    })
                  }
                : null,
            })
          }}
          handleCloseModal={props.hideLockWarningModal}
          featureName={"Trivia"}
          loading={props?.loading}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

TriviaChallenge = reduxForm({
  form: FORM_NAMES.TRIVIA_CHALLENGE,
  validate,
  initialValues: {
    trivia_challenge_form: {
      questions: [
        {
          answers: [
            { id: null, answer: "" },
            { id: null, answer: "" },
          ],
          id: null,
        },
      ],
    },
  },
})(TriviaChallenge)

const selector = formValueSelector(FORM_NAMES.TRIVIA_CHALLENGE)

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
  triviaChallenge: state.TriviaChallenge.triviaChallenge,
  triviaLoading: state.TriviaChallenge.loading,
  questions: selector(state, "trivia_challenge_form.questions"),
  formValues: selector(state, "trivia_challenge_form"),
  lockWarningModalIsOpen: state.menuFeatures.lockWarningModalIsOpen,
  loading: state.menuFeatures.loading,
})

const mapDispatchToProps = dispatch => ({
  addForm: (form, field, values) => dispatch(arrayPush(form, field, values)),
  initializeForm: values =>
    dispatch(
      initialize(FORM_NAMES.TRIVIA_CHALLENGE, {
        trivia_challenge_form: values,
      })
    ),
  addTriviaChallenge: values => dispatch(addTriviaChallenge(values)),
  getTriviaChallenge: values => dispatch(getTriviaChallenge(values)),
  resetTriviaChallenge: () => dispatch(resetTriviaChallenge()),
  updateTriviaChallenge: values => dispatch(updateTriviaChallenge(values)),
  cloneMenuFeature: values => dispatch(cloneMenuFeature(values)),
  hideLockWarningModal: () => dispatch(hideLockWarningModal()),
  displayLockWarningModal: () => dispatch(displayLockWarningModal()),
  getTriviaChallengeList: values => dispatch(getTriviaChallengeList(values)),
})

TriviaChallenge.propTypes = {
  feature: PropTypes.object,
  handleAddListItem: PropTypes.func,
  isListItem: PropTypes.bool,
  backButtonHandler: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(TriviaChallenge)
